import { Slide, SlideBody, SlideText, type SlideProps } from '@components'
import { Hoverable } from '@components/helpers'
import { useIsTouch } from '@hooks'
import { Box, SpotLight } from '@react-three/drei'
import { useEnvironment, useOverlay } from '@stores'
import { useEffect, useMemo, useState } from 'react'
import { Mesh, MeshBasicMaterial, MeshStandardMaterial } from 'three'

export function Lights(props: SlideProps) {
  const isTouch = useIsTouch()

  const setDemo = useOverlay(s => s.setDemo)
  const setLights = useEnvironment(s => s.setLights)

  const [box, setBox] = useState<Mesh | null>(null)
  const basicMaterial = useMemo(() => new MeshBasicMaterial({ color: 'red' }), [])
  const standardMaterial = useMemo(() => new MeshStandardMaterial({ color: 'red' }), [])

  const [toggleMaterial, setToggle] = useState(false)
  const material = toggleMaterial ? standardMaterial : basicMaterial
  const materialId = material.type

  useEffect(() => {
    setDemo(undefined)

    setTimeout(() => setLights(false), 500)
    return () => setLights(true)
  }, [setDemo, setLights])

  return (
    <Slide title="Lights and Materials" {...props}>
      <SlideBody bullet fontSize={0.25}>
        <SlideText onClick={() => window.open('https://threejs.org/docs#AmbientLight')}>
          AmbientLight
        </SlideText>
        <SlideText onClick={() => window.open('https://threejs.org/docs#DirectionalLight')}>
          DirectionalLight
        </SlideText>
        <SlideText onClick={() => window.open('https://threejs.org/docs#HemisphereLight')}>
          HemisphereLight
        </SlideText>
        <SlideText onClick={() => window.open('https://threejs.org/docs#PointLight')}>
          PointLight
        </SlideText>
        <SlideText onClick={() => window.open('https://threejs.org/docs#RectAreaLight')}>
          RectAreaLight
        </SlideText>
        <SlideText onClick={() => window.open('https://threejs.org/docs#SpotLight')}>
          SpotLight
        </SlideText>
      </SlideBody>

      <SlideBody position={[4, 0, 2.8]} fontSize={0.3}>
        <SlideText onClick={() => window.open(`https://threejs.org/docs#${materialId}`)}>
          {materialId}
        </SlideText>
      </SlideBody>

      <SlideBody position={[3.2, 0, 1.8]}>
        <SlideText fontSize={0.2}>👆{`${isTouch ? 'Touch' : 'Click'} Me`}</SlideText>
      </SlideBody>

      <SpotLight
        position={[2, 3, 2]}
        angle={0.3}
        penumbra={0.5}
        intensity={2}
        decay={0.5}
        castShadow
        target={box ?? undefined}
      />

      <Hoverable>
        <Box
          ref={setBox}
          position-y={0.5}
          material={material}
          onClick={e => {
            e.stopPropagation()
            setToggle(!toggleMaterial)
          }}
        />
      </Hoverable>
    </Slide>
  )
}
